// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : fulltext package
// =============================================================================

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as views from './views'
export {views}

export const parts = true
export const columns = true
export const templates = true
export const jobs = true

// VLM access
export const selectors = {
  fulltextAdminShowViewer: root =>
    root.ui.byId['Part/FulltextEditor/FulltextAdminOptions'].value.showViewer,
}
